import { createSignal } from 'solid-js'

export interface EmailNotVerifiedError {
  error: 'email_not_verified'
  action?: string
}

const [emailVerificationRequired, setEmailVerificationRequired] =
  createSignal<EmailNotVerifiedError | null>(null)

export { emailVerificationRequired, setEmailVerificationRequired }

const [inlinePromptCount, setInlinePromptCount] = createSignal(0)

export function claimInlineEmailPrompt(): () => void {
  setInlinePromptCount((n) => n + 1)
  let released = false
  return () => {
    if (released) {
      return
    }
    released = true
    setInlinePromptCount((n) => Math.max(0, n - 1))
  }
}

export const hasInlineEmailPrompt = () => inlinePromptCount() > 0
